import { forwardRef } from 'react';
import type { LucideProps } from 'lucide-react';

/**
 * Yin-yang icon for OneTaekwondo — Lucide-compatible sizing/stroke.
 */
const TaekwondoIcon = forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      color = 'currentColor',
      size = 24,
      strokeWidth = 2,
      absoluteStrokeWidth,
      className,
      ...rest
    },
    ref
  ) => {
    const computedStroke =
      absoluteStrokeWidth && typeof size === 'number'
        ? (Number(strokeWidth) * 24) / size
        : strokeWidth;

    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={computedStroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden={rest['aria-label'] ? undefined : true}
        {...rest}
      >
        <g transform="translate(12 12) rotate(90) scale(-1 1) translate(-12 -12)">
          <circle cx="12" cy="12" r="9" />
          {/* Classic S divide: top lobe then bottom lobe */}
          <path d="M12 3a4.5 4.5 0 0 1 0 9 4.5 4.5 0 1 0 0 9" />
          {/* Opposing dots */}
          <circle cx="12" cy="7.5" r="1.15" fill={color} stroke="none" />
          <circle cx="12" cy="16.5" r="1.15" fill={color} stroke="none" />
        </g>
      </svg>
    );
  }
);

TaekwondoIcon.displayName = 'TaekwondoIcon';

export default TaekwondoIcon;
